import req from '@/service/api';
import Store from '@/store/index';
const key = '/node';
const node = {
    getAll() {
        return req('GET', key + '/getAll');
    },
    getMainMenu() {
        return req('GET', key + '/getMainMenu');
    },
    create(params) {
        return Store.state.auth.authList.isEditer ? req('POST', key + '/create', params) : false;
    },
    setTopic(params) {
        const state = Store.state;
        return state.auth.authList.isEditer ? req('PUT', key + '/setTopic', params) : false;
    },
    swap(params) {
        return Store.state.auth.authList.isEditer ? req('PUT', key + '/swap', params) : false;
    },
    turn(params) {
        return Store.state.auth.authList.isEditer ? req('PUT', key + '/turnOnOff', params) : false;
    }
};
export default node;
